import { Router } from "@angular/router";
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpRequest,
} from "@angular/common/http";
import { catchError, map, share, switchMap, take, tap } from "rxjs/operators";
import { BehaviorSubject, EMPTY, Observable, of, Subject, throwError } from "rxjs";
import { environment, ENV_BUILD } from "src/environments/environment";
import { ApiError } from "src/app/shared/common/api-error";
import { Addon } from "src/app/shared/models/addon.model";
import { APP_APPEARANCE_ADDON_NAME } from "./app-appearance.service";
import { ExdrLanguageService } from "src/app/languages/services/exdr-language.service";
import { ProviderType } from "../../auth/types";
import { OtpMethod, SubTypeEnum } from "../enums/enums";
import { AppCheckTokenResult } from "firebase/app-check";
import { AppCheckService } from "./app-check.service";
import { LocalEnum } from "src/app/plannexe/shared/enums/localstorage";
import { PlannexeAppService } from "src/app/plannexe/shared/services/plannexe-app.service";
import { TabInterface } from "../interfaces/tab-interface";
import { LocalEnum as SellexeLocalEnum } from "src/app/sellexe/shared/enums/localstorage";
import { GoogleAnalyticsService } from "../google-analytics.service";
import { getEspOrgId } from "src/app/shared/services/esp-auth.service";
import { TranslateService } from "@ngx-translate/core";

export const ESP_LOGIN_DATA = "esp.login.data";
const IDENEDI_GROUP_ID_KEY = "user.chosen.idenedi.group.id";
const IDENEDI_USER_ID = "idenedi.user.id";
const IDENEDI_USER_CTRY = "idenedi.user.ctry";
const IDENEDI_TOKEN_STORAGE_KEY = "idenedi.auth.token";
const STEMEXE_IDENEDI_TOKEN_STORAGE_KEY = "stemexe.idenedi.auth.token";
export const IDENEDI_CODE_STORAGE_KEY = "idenedi.auth.code";
const TOKEN_EXPIRES_AT_KEY = "idenedi.auth.token-expires-at";
const STEMEXE_TOKEN_EXPIRES_AT_KEY = "stemexe.idenedi.auth.token-expires-at";
const REFRESH_TOKEN_STORAGE_KEY = "idenedi.auth.refresh-token";
const STEMEXE_REFRESH_TOKEN_STORAGE_KEY = "stemexe.idenedi.auth.refresh-token";
const NO_TOKEN_ERROR = "no.token.error";
const EXCEED_IDENEDI_GROUP_ID_KEY = "exceed.user.idenedi.group.id";

export const AUTH_TYPE_HEADER = "x-auth-type";

export enum AuthType {
  None = "none",
  Idenedi = "idenedi",
  Technadopt = "technadopt",
  ESP = "esp",
  SimpleStrata = "simple strata",
  Stemexe = "stemexe",
  OppPro = "OpportunityPro",
  CustomTab = "custom tab",
  Footer = "footer tab",
  Higher = "higher",
  PowerBi = "power bi",
  Intajy = "intajy",
  TabOrder = "tabOrder",
  AppAppearance = "App Appearance",
  EngagementPro = "Engpro",
  plannexe = "Engpro",
  Office365 = "",
  ChatBot = "",
  Plannexe = "plannexe",
  GroupLanguages = "GroupLanguages",
  VirtualRoom = 'Virtual Room',
  LeadLine = 'Lead Line',
  Tilda = 'Tilda',
  GlobalSearch = 'Global Search',
  GoogleAnalytics = 'GoogleAnalytics',
  NotificationService = 'Notification Service'
}

@Injectable({
  providedIn: "root",
})
export class AuthService {
  fakeToken: string;
  espOptions: any;
  ssOptions: any;
  private _expiresAt: number;
  private _addonsData: { [groupId: string]: Addon[] } = {};
  private _legacyTechnadoptAddon: Addon;
  private _idenediToken: string;
  private _groupWiseAddon$: { [groupId: string]: Observable<Addon[]> } = {};
  public registerClientDataProvider$: Subject<AuthType> = new Subject();
  public clearClientDataProviders$: Subject<void> = new Subject();
  footerTabSubject: Subject<void> = new Subject();
  logoutSubject$: Subject<void> = new Subject();
  toggleHiddenTabs$: Subject<void> = new Subject();
  loginRequired: boolean;
  isArabic: boolean = false;
  isAdmin: boolean = false;
  subdomainHasGroup = false;
  private _appAppearanceData$: Subject<void> = new Subject<void>();

  constructor(
    private http: HttpClient,
    private router: Router,
    private _exdrLanguageService: ExdrLanguageService,
    private readonly appCheckService: AppCheckService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private translate: TranslateService,
    private plannexeAppService: PlannexeAppService
    // private groupsService: GroupsService,
    // private authService: AuthService,
  ) {
    this.espOptions = {
      headers: this.buildAuthHeader(AuthType.ESP),
    };
    this.ssOptions = {
      headers: this.buildAuthHeader(AuthType.SimpleStrata),
    };
  }

  private loadStaticData() {
    this._addonsData["cc"].push({
      BaseUrl: "https://qaesp.azurewebsites.net/webapi",
      Type: "ESP",
      AccessToken:
        "xb6_t_BnO-lA_xaurWZp_-ftyFeoDEsMN5r2-A0GueAn0wisrWQMrvYxdO-2EVJWm5yVfGznBq0MVEROizgoUyShI5Txy7eRy4nmsCim7hMZmnhA7oX73rzSGA-CrveWMAE6L4pwfyn_rXLVPaFBU1qyBUL--cxrlqNdcwln32Qa7IgzaajTI8fdwGojHo9ys-wFk5MmMaNi91RtKs7bOufwOhTX2Et5nIec25Sx4qPN7th7B9THykhjDcnsNiuoL9w9bELgApiigz6P2vJEwkF9dq2VtjqyvW65GVJ6aKfOe66-wKseDzmaA3tnsKYccIlumLNypriIIT7vYt9VnQXinKHuNf9kSnTm2TeKQY8u03J_t-eqf8r-0OMNHOEGXesEWaK1OmKAoJhxaAver9EPaZZn9M8H3NGRoKI_mte0cwouoMqaB0KmHjz4iNtqW9wyFRXQHNGvpjhpuw6zG8LIKvit2zqGN2Tjivcast0yoiE7CAY_VzXGcLz0RF_5iIWr1dnbDF_P1_vfmO0zZWy4IZGvO1f2PwElbdXwLPwL98Aqfmbz08cxiEJjzIAeMjalKykDif5LbUokMOUVz9xXkGDROP9RsJfLxC9BBL_ylb5FnDmg34f5ZwsB1cCLyfZ6j_7OgdIVNA6k9U5GE9FpjWMggZAODH7kPDSv4JlEnJkju2z-v-F4Fa8ytXR4XbqqZZ5ffM8m79rzgt2Vgf6S3EuPxVvd2Vma3BPrNMlCjRkpevDPvoTur5nffSFPnFa5dCyTwG4s0jRMphDHGPavWWTXr-MMfaDXRoxYKW0FgCPkF_Ebjk3nOQ2rwwdMW2w6OzjuGNJNjM9AMqukkTSv4AIZs96okUI80zy3DXGMhgJiSFFQXtDtyBlhz8jt",
      OrganziationId: 176,
    });
    // 3333-44-0344
  }

  get idenediToken(): string {
    if (!this._idenediToken) {
      this._idenediToken = localStorage.getItem(STEMEXE_IDENEDI_TOKEN_STORAGE_KEY ?? IDENEDI_TOKEN_STORAGE_KEY);
    }
    return this._idenediToken;
  }

  set idenediToken(value: string) {
    this._idenediToken = value;
    if (value) {
      localStorage.setItem(STEMEXE_IDENEDI_TOKEN_STORAGE_KEY, value);
      this.clearCachedAddons(this.idenediGroupId);
    } else {
      localStorage.removeItem(STEMEXE_IDENEDI_TOKEN_STORAGE_KEY ?? IDENEDI_TOKEN_STORAGE_KEY);
    }
  }

  get idenediTokenExpiresAt(): number {
    if (!this._expiresAt) {
      this._expiresAt = +localStorage.getItem(STEMEXE_TOKEN_EXPIRES_AT_KEY ?? TOKEN_EXPIRES_AT_KEY);
    }
    return this._expiresAt;
  }

  set idenediTokenExpiresAt(value: number) {
    this._expiresAt = value;
    if (value) {
      localStorage.setItem(STEMEXE_TOKEN_EXPIRES_AT_KEY, value + "");
    } else {
      localStorage.removeItem(STEMEXE_TOKEN_EXPIRES_AT_KEY ?? TOKEN_EXPIRES_AT_KEY);
    }
  }

  get idenediGroupId(): string {
    if (environment.enableGroupsSelection) {
      return localStorage.getItem(IDENEDI_GROUP_ID_KEY);
    }
    return environment.idenediGroupId;
  }

  set idenediGroupId(value: string) {
    // if (environment.enableGroupsSelection) {
    if (!value) {
      localStorage.removeItem(IDENEDI_GROUP_ID_KEY);
    } else {
      localStorage.setItem(IDENEDI_GROUP_ID_KEY, value);
    }
    // } else {
    //   throw new Error("This functionality is disabled");
    // }
  }

  // get idenediGroupIdForActivities(): string {
  //   if (environment.enableGroupsSelection) {
  //     return this.idenediGroupId;
  //   }
  //   return environment.idenediGroupIdForActivities;
  // }

  get showHiddenTabs(): boolean {
    let showHiddenTabs: string[] = JSON.parse(localStorage.getItem('showHiddenTabs') ?? '[]');
    return showHiddenTabs.some(s => s == this.idenediGroupId + '-' + this.getCurrentUserId());
  }

  set showHiddenTabs(value: boolean) {

    let showHidden: string[] = JSON.parse(localStorage.getItem('showHiddenTabs') ?? '[]');

    if (!value) {
      showHidden = showHidden.filter(s => s != this.idenediGroupId + '-' + this.getCurrentUserId())
    } else {
      if (!this.showHiddenTabs) {
        showHidden.push(this.idenediGroupId + '-' + this.getCurrentUserId())
      }
    }

    localStorage.setItem('showHiddenTabs', JSON.stringify(showHidden));
  }

  public get isExceeders(): boolean {
    return environment.build == ENV_BUILD.EXCEEDERS;
  }

  isLoggedIn(): boolean {
    return !!this.idenediToken;
  }

  isIdenediTokenExpired(): boolean {
    // If no expiry is set but token exists, assume expired for safety
    if (!this.idenediTokenExpiresAt) {
      return this.isLoggedIn(); // Treat as expired if logged in but no expiry timestamp
    }
    // 1 minute delay to refresh token
    return Date.now() > this.idenediTokenExpiresAt - 60 * 1000;
  }

  private _getToken(data: string) {
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return this.http
      .post<any>(`${environment.idenediProviderUrl}/oauth/token`, data, {
        headers,
      })
      .pipe(
        tap(({ access_token, refresh_token, expires_in = 604799, idenedi }) => {
          this.idenediToken = access_token;
          this.idenediTokenExpiresAt = Date.now() + expires_in * 1000;
          localStorage.setItem(STEMEXE_REFRESH_TOKEN_STORAGE_KEY, refresh_token);
          localStorage.setItem(IDENEDI_USER_ID, idenedi);
        }),
        catchError((e) => {
          throw ApiError.fromResponse(e);
        })
      );
  }

  getUserIdenedi(): string {
    return localStorage.getItem("idenedi.user.id");
  }

  getToken(options: {
    login: string;
    password: string;
    countryCode: string;
    regToken?: string
    twoFaKey?: string,
    twoFaCode?: string
  }): Observable<any> {
    const encodedPassword = this.encodePassword(options.password);
    let params = {
      grant_type: "password",
      client_id: environment.authClientId,
      client_secret: environment.authClientSecret,
      username: options.login,
      password: encodedPassword,
      region: options.countryCode,
    }
    if (options?.twoFaKey && options?.twoFaCode) {
      params['2fa_key'] = options.twoFaKey;
      params['2fa_code'] = options.twoFaCode;
    }
    if (options?.regToken) {
      params['reg_token'] = options.regToken
    }
    let queryString = new URLSearchParams(params).toString();
    return this._getToken(queryString).pipe(
      tap((res) => {
        localStorage.setItem(IDENEDI_USER_CTRY, options?.countryCode);
      })
    );
  }

  getTokenForProvider(options: {
    type: ProviderType,
    code: string,
    instanceId: string,
    agentId?: string,
    email?: string,
    username?: string,
    password?: string,
    twoFaKey?: string,
    twoFaCode?: string,
    redirectUri?: string,
    regToken?: string,
    extUserKey?: string
  }): Observable<any> {
    if (options.password) {
      options.password = this.encodePassword(options.password);
    }
    let body = {
      grant_type: options.type,
      client_id: environment.authClientId,
      client_secret: environment.authClientSecret,
      code: options.code,
      instance_id: options?.instanceId
    };
    if (this.idenediGroupId) {
      body['gIdenedi'] = this.idenediGroupId;
    }
    if (options?.twoFaKey && options?.twoFaCode) {
      body['2fa_key'] = options.twoFaKey;
      body['2fa_code'] = options.twoFaCode;
    }
    if (options?.regToken) {
      body['reg_token'] = options.regToken
    }
    switch (options.type) {
      case ProviderType.EMAIL_OTP:
        body["email"] = options.email;
        break;
      case ProviderType.ESP_USER_LIST:
        body["username"] = options.username;
        body["password"] = options.password;
        body["provider_id"] = options.agentId;
        delete body["code"];
        break;
      case ProviderType.AZURE_AD:
      case ProviderType.GOOGLE:
      case ProviderType.APPLE:
        body['redirect_uri'] = options.redirectUri;
        body['provider_id'] = options.agentId;
        
        // body["agent_id"] = options.agentId;
        break;
      case ProviderType.EXTERNAL_AUTH:
        body['provider_id'] = options.agentId;
        body["agent_id"] = options.agentId;
        body['ext_user_key'] = options.extUserKey;
        delete body["code"];
        break;
      default:
        body["agent_id"] = options.agentId;
        break;
    }
    console.log("getTokenForProvider body", body);
    const queryString = new URLSearchParams(body).toString();
    return this._getToken(queryString);
  }

  getDPWUAETokenForProvider(url: string, options: {
    AuthCode: string,
    RedirectUri: string,
    GroupIdenedi: string,
    ProviderInstanceId: string,
    ProviderId: string,
    IdenediClientId: string,
    IdenediClientSecret: string
  }) {

    return this.http
      .post<any>(`${url}/oauth/token`, options)
      .pipe(
        tap(({ access_token, refresh_token, expires_in = 604799, idenedi }) => {
          this.idenediToken = access_token;
          this.idenediTokenExpiresAt = Date.now() + expires_in * 1000;
          localStorage.setItem(STEMEXE_REFRESH_TOKEN_STORAGE_KEY, refresh_token);
          localStorage.setItem(IDENEDI_USER_ID, idenedi);
        }),
        catchError((e) => {
          console.log('oAuthTokenError', e)
          return throwError(() => e);
        })
      );
  }

  getEmailOtpForProvider(email, groupIdenedi): Observable<any> {
    let url = `${environment.idenediProviderUrl}/api/account/SendEmailOTP`;
    let body = { EmailAddress: email, GroupIdenedi: groupIdenedi };
    return this.http.post(url, body);
  }

  tryRefreshIdenediToken(): Observable<any> {
    const refreshToken = localStorage.getItem(STEMEXE_REFRESH_TOKEN_STORAGE_KEY ?? REFRESH_TOKEN_STORAGE_KEY);
    if (!refreshToken) {
      throw NO_TOKEN_ERROR;
    }
    return this.refreshToken(refreshToken).pipe(
      map(({ access_token }) => access_token)
    );
  }

  refreshTokenInProgress = false;
  tokenRefreshedSource: Subject<void> = new Subject();
  tokenRefreshed$ = this.tokenRefreshedSource.asObservable();
  
  refreshToken(refreshToken: string): Observable<any> {
    if (this.refreshTokenInProgress) {
      // Use take(1) so the subscription auto-completes after the pulse
      return this.tokenRefreshed$.pipe(take(1));
    } else {
      this.refreshTokenInProgress = true;

      return this.refreshTokenInternal(refreshToken).pipe(
        tap(() => {
          this.refreshTokenInProgress = false;
          this.tokenRefreshedSource.next();
        }),
        catchError((err) => {
          this.refreshTokenInProgress = false;
          // Notify current waiters of the error, then recreate the Subject
          // so future calls are not permanently broken (Subject is dead after error())
          const deadSource = this.tokenRefreshedSource;
          this.tokenRefreshedSource = new Subject<void>();
          this.tokenRefreshed$ = this.tokenRefreshedSource.asObservable();
          deadSource.error(err);
          return throwError(() => err);
        })
      );
    }
  }

  refreshTokenInternal(refreshToken: string): Observable<any> {
    const body = new HttpParams({
      fromObject: {
        grant_type: "refresh_token",
        client_id: environment.authClientId,
        client_secret: environment.authClientSecret,
        refresh_token: refreshToken,
      },
    });
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return this.http
      .post<any>(
        `${environment.idenediProviderUrl}/oauth/token`,
        body.toString(),
        { headers }
      )
      .pipe(
        tap(({ access_token, refresh_token, expires_in, idenedi }) => {
          this.idenediToken = access_token;
          this.idenediTokenExpiresAt = Date.now() + expires_in * 1000;
          localStorage.setItem(STEMEXE_REFRESH_TOKEN_STORAGE_KEY, refresh_token);
          localStorage.setItem(IDENEDI_USER_ID, idenedi);
        }),
        catchError((error) => {
          // Use setTimeout to let the current error chain unwind before navigating
          setTimeout(() => {
            if (this.isIdenediTokenExpired()) {
              this.logout();
            }
          }, 0);
          return throwError(() => error);
        })
      );
  }

  ensureIdenediToken(): Observable<string> {
    if (!this.isLoggedIn()) {
      return of(null);
    }
    if (this.isIdenediTokenExpired()) {
      return this.tryRefreshIdenediToken().pipe(catchError(() => of(null)));
    }
    return of(this.idenediToken);
  }

  /**
   * @deprecated please use getToken(...) to sign in
   */
  login(
    phoneNumber: string,
    password: string,
    countryCode: string
  ): Observable<string> {
    const body: any = {
      Identity: phoneNumber,
      Password: password,
      Region: countryCode,
    };
    return this.http
      .post(`${environment.idenediProviderUrl}/api/account/Login`, body)
      .pipe(
        map((response: any) => response.Token),
        tap((token) => (this.idenediToken = token)),
        catchError((e) => {
          throw ApiError.fromResponse(e);
        })
      );
  }

  sendVerificationSMSNoToken(options: {
    login: string,
    isNewUser: boolean,
    countryCode: string,
    otpMethod: OtpMethod,
    ExtUserKey?: string,
  }): Observable<any> {
    const body: any = options.ExtUserKey
      ? {
        ExtUserKey: options.ExtUserKey,
      }
      : options.isNewUser
        ? {
          PhoneNumber: options.login,
        }
        : {
          PhoneNumber: options.login,
        };
    if (options.countryCode && !options.ExtUserKey) {
      body.Region = options.countryCode;
    }
    if (options.ExtUserKey && !options.isNewUser) {
      body.IsExistingUser = true;
    }
    body.Channel = options.otpMethod;

    // Initialize headers, potentially with values that do not include an auth token
    let headers = new HttpHeaders();

    // Add any additional headers here, except for the auth token
    if (this.idenediGroupId) {
      body['gIdenedi'] = this.idenediGroupId;
      headers = headers.append("x-idenedi-groupid", this.idenediGroupId);
    }
    if (!environment?.enableAppCheck) {
      headers = headers.append("Idenedi-Api-Version", "1");
    }

    // Prepare the request options
    const requestOptions = { headers: headers };

    // Perform the HTTP POST request
    return this.http.post(
      `${environment.idenediProviderUrl}/api/account/SendSMSVerificationCode`,
      body,
      requestOptions
    ).pipe(
      catchError((error) => {
        // Handle the error appropriately
        throw ApiError.fromResponse(error);
      })
    );
  }


  sendVerificationSMS(options: {
    login: string,
    isNewUser: boolean,
    countryCode: string,
    otpMethod: OtpMethod,
    ExtUserKey?: string,
  }): Observable<any> {
    const body: any = options.ExtUserKey
      ? {
        ExtUserKey: options.ExtUserKey,
      }
      : options.isNewUser
        ? {
          PhoneNumber: options.login,
        }
        : {
          Identity: options.login,
        };
    if (options.countryCode && !options.ExtUserKey) {
      body.Region = options.countryCode;
    }
    if (options.ExtUserKey && !options.isNewUser) {
      body.IsExistingUser = true;
    }
    body.Channel = options.otpMethod;
    return this.appCheckService.getToken().pipe(
      catchError((err) => of({})),
      take(1), // See https://stackoverflow.com/a/60196923/828547.
      switchMap((token: AppCheckTokenResult | undefined) => {
        let appCheckToken;
        if (token) {
          appCheckToken = token?.token;
        }
        let headers = this.buildAuthHeader(AuthType.Idenedi);

        if (this.idenediGroupId) {
          body['gIdenedi'] = this.idenediGroupId;
          headers = headers.append("x-idenedi-groupid", this.idenediGroupId);
        }
        if (appCheckToken) {
          headers = headers.append("x-firebase-appcheck", appCheckToken);
        }
        if (!environment?.enableAppCheck) {
          headers = headers.append("Idenedi-Api-Version", "1");
        }
        const options = { headers: headers };

        return this.http.post(
          `${environment.idenediProviderUrl}/api/account/SendSMSVerificationCode`,
          body,
          options
        );
      }),
      catchError((error) => {
        // server-side error
        throw ApiError.fromResponse(error);
      })
    );
  }

  verifySMSCode(
    login: string,
    code: string,
    isNewUser: boolean = true,
    ExtUserKey?: string,
    countryCode?: string
  ): Observable<any> {
    const body: any = ExtUserKey
      ? {
        ExtUserKey,
      }
      : isNewUser
        ? {
          PhoneNumber: login,
        }
        : {
          Identity: login,
        };
    body["VerificationCode"] = code;
    if (countryCode) {
      body.Region = countryCode;
    }
    return this.http
      .post(
        `${environment.idenediProviderUrl}/api/account/VerifySMSVerificationCode`,
        body
      )
      .pipe(
        catchError((e) => {
          throw ApiError.fromResponse(e);
        })
      );
  }

  extListQuery(body: any) {
    const instanceId = body.instanceId;
    delete body["instanceId"];
    return this.http.post(
      `${environment.apiHost}/api/${this.idenediGroupId}/externalIdProvider/${instanceId}/ext_list_query`,
      body
    );
  }

  register(options: {
    firstName: string;
    lastName: string;
    password: string;
    phoneNumber: string;
    verificationCode: number;
    countryCode: string;
    ExtUserKey: string;
  }): Observable<string> {
    const encodedPassword = this.encodePassword(options.password);
    let body = {};
    body = {
      FirstName: options.firstName,
      LastName: options.lastName,
      PhoneNo: options.phoneNumber,
      VerificationCode: options.verificationCode,
      Password: encodedPassword,
      Country: options.countryCode,
    };
    if (options?.ExtUserKey) {
      body = {
        VerificationCode: options.verificationCode,
        Password: encodedPassword,
        ExtUserKey: options.ExtUserKey,
      };
    }
    return this.http
      .post<any>(`${environment.idenediProviderUrl}/api/account/Register`, body)
      .pipe(
        catchError((e) => {
          throw ApiError.fromResponse(e);
        })
      );
  }

  resetPassword(
    login: string,
    code: string,
    password: string,
    countryCode?: string,
    ExtUserKey?: any
  ) {
    password = this.encodePassword(password);
    let body: any = {
      Identity: login,
      NewPassword: password,
      VerificationCode: code,
    };
    if (countryCode) {
      body.Region = countryCode;
    }
    if (ExtUserKey) {
      body = {
        VerificationCode: code,
        NewPassword: password,
        ExtUserKey: ExtUserKey,
      };
    }
    return this.http
      .post(`${environment.idenediProviderUrl}/api/account/ResetPassword`, body)
      .pipe(
        catchError((e) => {
          throw ApiError.fromResponse(e);
        })
      );
  }

  encodePassword(password: string) {
    let pwd = password;
    let utf8 = unescape(encodeURIComponent(pwd));
    let pwd_bytes = [];
    for (var i = 0; i < utf8.length; i++) {
      pwd_bytes.push(utf8.charCodeAt(i));
    }
    let r = this.generateRandomByte();
    let xor_pwd_bytes = [];
    for (let i = 0; i < pwd_bytes.length; i++) {
      xor_pwd_bytes.push(pwd_bytes[i] ^ r);
    }
    const header_bytes = [0x00, 0x1a, 0x04, 0xfb, 0xe5, 0xff];
    let final_bytes = header_bytes.concat([r]).concat(xor_pwd_bytes);
    let b64 = btoa(
      String.fromCharCode.apply(null, new Uint8Array(final_bytes))
    );
    return b64;
  }

  generateRandomByte() {
    let r;
    if (window.crypto) {
      const array = new Uint8Array(1);
      self.crypto.getRandomValues(array);
      r = array[0];
    } else {
      r = Math.random();
    }
    r = (r % 240) + 16;
    return r;
  }

  clearLocalStorage() {
    this.idenediToken = null;
    localStorage.removeItem(STEMEXE_REFRESH_TOKEN_STORAGE_KEY ?? TOKEN_EXPIRES_AT_KEY);
    this.idenediTokenExpiresAt = null;

    localStorage.removeItem(IDENEDI_GROUP_ID_KEY);
    localStorage.removeItem(IDENEDI_USER_ID);
    localStorage.removeItem(EXCEED_IDENEDI_GROUP_ID_KEY);
    localStorage.removeItem(IDENEDI_USER_CTRY);
    localStorage.removeItem("higherUser");
    sessionStorage.removeItem(ESP_LOGIN_DATA);
    localStorage.removeItem(IDENEDI_CODE_STORAGE_KEY);

    localStorage.removeItem(LocalEnum.isloggedin);
    localStorage.removeItem(LocalEnum.token);
    localStorage.removeItem(LocalEnum.user);
    localStorage.removeItem("userTeam");
    localStorage.removeItem(SellexeLocalEnum.isloggedin);
    localStorage.removeItem(SellexeLocalEnum.user);
    localStorage.removeItem(LocalEnum.SubGroupSelection);
    localStorage.removeItem('userAgency')

    this._addonsData = {};
    this._groupWiseAddon$ = {};
    this.removeEspToken();
  }

  // Plannexe ki taraf se maanga gaya naya audit endpoint -- Logout hote hi ek record Plannexe
  // database me save hota hai. Plannexe token/user data clearLocalStorage() se pehle padhna
  // zaroori hai, warna wo already null ho chuke hote hain.
  private logUserAuditLogout(): void {
    const plannexeToken = localStorage.getItem(LocalEnum.token);
    if (!plannexeToken) {
      // User plannexe me is session me kabhi login hi nahi hua -- audit karne ke liye kuch nahi.
      return;
    }
    let plannexeUser: any = {};
    try {
      plannexeUser = JSON.parse(localStorage.getItem(LocalEnum.user) || '{}') || {};
    } catch {
      plannexeUser = {};
    }
    const body = {
      userId: parseInt(plannexeUser.userId, 10) || 0,
      idenedi: this.getUserIdenedi() || '',
      firstName: plannexeUser.firstName || '',
      lastName: plannexeUser.lastName || '',
      email: plannexeUser.email || '',
      phone: plannexeUser.phone || '',
      userRole: 0,
      organizationId: parseInt(plannexeUser.organizationId, 10) || 0,
      sessionId: '',
      activityType: 'Logout',
      ipAddress: '',
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
    };
    const headers = new HttpHeaders({ Authorization: 'Bearer ' + plannexeToken });
    // Fire-and-forget: audit logging should never block or fail the actual logout.
    this.http.post(this.plannexeAppService.plannexeBaseUrl + '/api/UserAuditLog/Logout', body, { headers }).subscribe({
      error: (err) => console.warn('User audit log (Logout) failed:', err),
    });
  }

  private loggingOut = false;

  logout(redirectToLogin: boolean = true): void {
    if (this.loggingOut) return;
    this.loggingOut = true;
    this.logUserAuditLogout();

    // Revoke token silently - don't let errors block logout
    this.revokeToken().subscribe({
      next: (value) => {
        if (!value) {
          console.warn('No token to revoke or token already expired');
        }
        if (environment.enableGroupsSelection) {
          this.idenediGroupId = null;
        }
        if (redirectToLogin) {
          if (
            !environment.enableGroupsSelection &&
            environment.singleGroupApp &&
            !this.loginRequired
          ) {
            // Public single-group app: go to home after logout
            this.logoutAndRedirectToLogin();
          } else {
            // Always redirect to login when logging out
            this.logoutAndRedirectToLogin();
          }
        }
        this.loggingOut = false;
      },
      error: (err) => {
        console.warn('Token revoke failed (expected if token already expired):', err);
        if (environment.enableGroupsSelection) {
          this.idenediGroupId = null;
        }
        if (redirectToLogin) {
          this.logoutAndRedirectToLogin();
        }
        this.loggingOut = false;
      }
    });

    this.clearLocalStorage();
  }

  logoutAndRedirectToLogin() {
    this.logoutSubject$.next();
    this.router.navigate(["/auth/login"]);
  }

  revokeToken() {
    const url = `${environment.idenediProviderUrl}/api/oauth/revoke`;
    const options = { headers: this.buildAuthHeader(AuthType.Idenedi) };
    const refreshToken = localStorage.getItem(STEMEXE_REFRESH_TOKEN_STORAGE_KEY ?? REFRESH_TOKEN_STORAGE_KEY);
    if (!refreshToken) {
      // No refresh token, nothing to revoke - return empty observable
      return of(null);
    }
    return this.http.post(url, {
      token: refreshToken,
      token_type_hint: 'refresh_token'
    }, options).pipe(
      catchError(err => {
        // Ignore revoke errors - token may already be invalid
        console.warn('Token revoke API failed:', err);
        return of(null);
      })
    );
  }
  getCurrentUserId(): string {
    return localStorage.getItem(IDENEDI_USER_ID);
  }
  getCurrentUserCountry(): string {
    return localStorage.getItem(IDENEDI_USER_CTRY) ?? null;
  }
  /**
   * Drops the cached group addons so the next getAddonsAuth() re-fetches them
   * from the backend with fresh AccessTokens. Used to recover from a 401 when an
   * addon's baked-in AccessToken has expired without a full re-login (bug 34400).
   */
  invalidateAddonsCache(groupId: string = this.idenediGroupId): void {
    if (!groupId) {
      return;
    }
    this._addonsData[groupId] = null;
    if (this._groupWiseAddon$) {
      delete this._groupWiseAddon$[groupId];
    }
  }

  // This method is responsible to get and set all addons that system supports for now Technadopt and Esp is handled
  getAddonsAuth(groupId: string, changeLanguage = true): Observable<Addon[]> {
    if (!groupId) {
      return of([]);
    }
    // not refresh member case data addon call ka thats why coment these lines ...
    let selectedGroupAddons = null; 
    if (!selectedGroupAddons && this._addonsData[groupId]) {
      selectedGroupAddons = of(this._addonsData[groupId]);
    }
    if (!selectedGroupAddons && this._groupWiseAddon$[groupId]) {

      selectedGroupAddons = this._groupWiseAddon$[groupId];
    }

    if (!selectedGroupAddons) {
      const url = `${environment.apiHost}/api/group/${groupId}/addon`;
      const options = { headers: this.buildAuthHeader(AuthType.Idenedi) };
  
      let request$ =
        window["GROUP_ADDONS"] && !this.isLoggedIn()
          ? of(
            JSON.parse(decodeURIComponent(escape(atob(window["GROUP_ADDONS"]))))
          )
          : this.http.get<any>(url, options);
  
      selectedGroupAddons = request$
        .pipe(
          map((addons: any[]) => {
            console.log(addons);
            if (!this._addonsData[groupId]) {
              this._addonsData[groupId] = [];
            }
  
            this.clearClientDataProviders$.next();
            addons = addons.map((addon) => {
              //temp fix for redundant requests
              if (addon["exists"]) {
                return addon;
              } else {
                addon["exists"] = true;
              }
              this.registerClientDataProvider$.next(addon.Type);
              let tempAddon: Addon = new Addon();
              tempAddon = { ...addon };
              tempAddon.InstanceId = addon.InstanceId;
              tempAddon.BaseUrl = addon.BaseUrl ?? null;
              tempAddon.AccessToken = addon.AccessToken ?? null;
              switch (addon.Type.toLowerCase()) {
                case AuthType.SimpleStrata.toLowerCase():
                  tempAddon.Type = AuthType.SimpleStrata;
                  tempAddon.OrganziationId = addon.PublicProperties[
                    "organziationId"
                  ]
                    ? +addon.PublicProperties["organziationId"]
                    : null;
                  tempAddon.AccessToken = null;
                  localStorage.setItem(
                    "organziationId",
                    addon.PublicProperties.organziationId
                  );
  
                  break;
  
                case AuthType.Technadopt.toLowerCase():
                  tempAddon.Type = AuthType.Technadopt;
                  tempAddon.OrganziationId =
                    addon?.PublicProperties?.organziationId ?? null;
  
                  tempAddon.AccessToken = addon.AccessToken;
  
                  if (addon.PublicProperties["subgroupsAccessList"]) {
                    addon.PublicProperties.subgroupsAccessList = JSON.parse(
                      addon.PublicProperties.subgroupsAccessList
                    );
                  } else {
                    addon.PublicProperties["subgroupsAccessList"] = [];
                  }
                  tempAddon.PublicProperties = addon?.PublicProperties;
  
                  tempAddon.HomeTopicId =
                    addon?.PublicProperties?.homeTopicId || null;
                  tempAddon.technadoptAuthData = null;
  
                  break;
                case AuthType.ESP.toLowerCase():
                  tempAddon.Type = AuthType.ESP;
                  tempAddon.BaseUrl = addon.BaseUrl;
                  tempAddon.AccessToken = null; //addon.AccessToken; // added acces token cause it is used in dataProvider
                  // tempAddon.OrganziationId = addon.PublicProperties[
                  //   "organziationId"
                  // ]
                  //   ? +addon.PublicProperties["organziationId"]
                  //   : null;
  
                  // const orgId = addon.PublicProperties["organziationId"];
                  const orgId = getEspOrgId(addon);
                  localStorage.setItem("espOrganziationId", orgId);
                  tempAddon.OrganziationId = orgId;
                  tempAddon.Configuration = addon.Configuration;
  
                  if (addon.PublicProperties["subgroupsAccessList"]) {
                    try {
                      addon.PublicProperties.subgroupsAccessList = JSON.parse(
                        addon.PublicProperties.subgroupsAccessList
                      );
                    } catch (error) {
                      addon.PublicProperties.subgroupsAccessList = [];
                    }
                  } else {
                    addon.PublicProperties["subgroupsAccessList"] = [];
                  }
                  if (addon.PublicProperties["claimOwnershipData"]) {
                    tempAddon.espClaimOwnershipData = JSON.parse(
                      addon.PublicProperties["claimOwnershipData"]
                    );
                  }
  
                  tempAddon.PublicProperties = addon?.PublicProperties;
                  break;
  
                case AuthType.Higher.toLowerCase():
                  tempAddon.Type = AuthType.Higher;
                  tempAddon.BaseUrl = addon.BaseUrl;
                  tempAddon.Domain = addon.PublicProperties.domain;
                  tempAddon.GroupIdenedi = addon.PublicProperties.groupIdenedi;
                  tempAddon.OrganziationId = addon.PublicProperties[
                    "organziationId"
                  ]
                    ? +addon.PublicProperties["organziationId"]
                    : null;
  
                  let teamIds = [];
                  if (addon.PublicProperties["homeTopicId"]) {
                    teamIds = addon.PublicProperties["homeTopicId"].split(",");
                  }
                  tempAddon.TeamIds = teamIds;
                  break;
                case AuthType.PowerBi.toLowerCase():
                  tempAddon.Type = AuthType.PowerBi;
                  tempAddon.AccessToken = addon.AccessToken;
                  tempAddon.BaseUrl = addon.BaseUrl;
                  tempAddon.OrganziationId = addon.PublicProperties[
                    "organziationId"
                  ]
                    ? +addon.PublicProperties["organziationId"]
                    : null;
                  if (addon.PublicProperties["powerBiData"]) {
                    addon.PublicProperties.powerBiData = JSON.parse(
                      addon.PublicProperties.powerBiData
                    );
                  }
                  if (addon.PublicProperties["powerBiReportData"]) {
                    addon.PublicProperties.powerBiReportData = JSON.parse(
                      addon.PublicProperties.powerBiReportData
                    );
                  }
                  tempAddon.PublicProperties = addon.PublicProperties;
                  break;
                case AuthType.TabOrder.toLowerCase():
                  tempAddon = this.initTabOrderAddon(addon);
                  break;
                case AuthType.GroupLanguages.toLowerCase():
                  tempAddon = this.initGroupLangAddon(addon);
                  break;
                case AuthType.CustomTab.toLowerCase():
                  tempAddon = addon as Addon;
                  tempAddon.PublicProperties.customTabId = tempAddon.InstanceId;
                  if (addon.PublicProperties?.visibleBy) {
                    tempAddon.PublicProperties.visibleBy = JSON.parse(
                      addon.PublicProperties.visibleBy
                    );
                  }
                  if (addon.PublicProperties?.hiddenFrom) {
                    tempAddon.PublicProperties.hiddenFrom = JSON.parse(
                      addon.PublicProperties.hiddenFrom
                    );
                  } else {
                    tempAddon.PublicProperties.hiddenFrom = [];
                  }
                  if (addon.PublicProperties?.bannerData) {
                    tempAddon.PublicProperties.bannerData = JSON.parse(
                      addon.PublicProperties.bannerData
                    );
                  }
  
                  if(addon.PublicProperties?.allowFeedOptions) {
                    tempAddon.PublicProperties.allowFeedOptions = JSON.parse(
                      addon.PublicProperties.allowFeedOptions
                    );
                  } else {
                    tempAddon.PublicProperties.allowFeedOptions = { likes: true, comments: true, announcer: true };
                  }
                  
                  tempAddon.PublicProperties.isLandingPageTab = [
                    "1",
                    1,
                    true,
                  ].includes(addon.PublicProperties.isLandingPageTab);
                  break;
                case AuthType.Footer.toLowerCase():
                  tempAddon = addon as Addon;
                  tempAddon.PublicProperties.customTabId = tempAddon.InstanceId;
                  if (addon.PublicProperties?.visibleBy) {
                    tempAddon.PublicProperties.visibleBy = JSON.parse(
                      addon.PublicProperties.visibleBy
                    );
                  }
                  if (addon.PublicProperties?.hiddenFrom) {
                    tempAddon.PublicProperties.hiddenFrom = JSON.parse(
                      addon.PublicProperties.hiddenFrom
                    );
                  } else {
                    tempAddon.PublicProperties.hiddenFrom = [];
                  }
                  if (addon.PublicProperties?.bannerData) {
                    tempAddon.PublicProperties.bannerData = JSON.parse(
                      addon.PublicProperties.bannerData
                    );
                  }
                  break;
                case AuthType.NotificationService.toLowerCase():
                  tempAddon.BaseUrl = tempAddon.PublicProperties?.apiUrl;
                  break;
                case AuthType.GoogleAnalytics.toLowerCase():
                  const measurementId = tempAddon.PublicProperties?.MeasurementId;
                  this.googleAnalyticsService.setMeasurementId(measurementId);
                  break;
  
                default:
                  tempAddon = addon as Addon;
                  break;
              }
  
              return tempAddon;
              // this._addonsData[groupId].push(tempAddon);
            });
  
            this._addonsData[groupId] = addons ?? [];
            return this._addonsData[groupId];
          }),
          tap(() => {
            if (!groupId) {
              return;
            }
            // this._groupWiseAddon$[groupId].next(this._addonsData[groupId]);
            // this._groupWiseAddon$[groupId].unsubscribe();
            this._groupWiseAddon$[groupId] = null;
            if (changeLanguage) {
              this.changeLanguage(groupId);
            }
          }),
          catchError(error => {
            console.error('getAddonsAuth failed:', error);
            // Clear the cached request so it can be retried
            this._groupWiseAddon$[groupId] = null;
            // Return empty array to allow app to continue
            return of([]);
          })
        )
      // .pipe(share());
    }

    
    return selectedGroupAddons.pipe(
      tap((addons: any[]) => {
        this.setAppAppearanceData(addons);
      })
    );
  }

  setAppAppearanceData(addons: any[]) {
    let appAppearanceAddonData = null;
    try {
      let appAppearanceAddon = addons.find(
        (addon) => addon.Type?.toLowerCase() === AuthType.AppAppearance.toLowerCase()
      );
      appAppearanceAddonData = appAppearanceAddon?.PublicProperties
        ? appAppearanceAddon.PublicProperties
        : null;
      this._appAppearanceData$.next(appAppearanceAddonData);
    } catch (e) {
      console.error('Invalid JSON in PublicProperties.jsonData', e);
    }
  }

  getAppAppearanceData(): Observable<any> {
    return this._appAppearanceData$.asObservable();
  }



  changeLanguage(groupId: string) {
    const langAddon = this._addonsData[groupId]?.find(
      (a) => a.Type === AuthType.GroupLanguages
    );
    const langData = langAddon?.PublicProperties?.jsonData ?? {};

    const langArray: string[] = Object.keys(langData).filter((locale) => {
      return [1, "1", true].includes(langData[locale]?.settings?.isEnable);
    });
    const defaultLang: string = Object.keys(langData).find((locale) => {
      return [1, "1", true].includes(langData[locale]?.settings?.isDefault);
    });
    return this._exdrLanguageService.initializeLanguage(groupId, langArray, defaultLang);
  }

  nestedTabGroupAddon(): void {
    const groupId = this.idenediGroupId;
    const url = `${environment.apiHost}/api/group/${groupId}/addon`;
    const options = { headers: this.buildAuthHeader(AuthType.Idenedi) };

    this.http.get<any>(url, options).subscribe(
      (response) => {
        // Store the response in a variable
        const apiResponse = response;

        // Console the response
        console.log(apiResponse);

        // You can also perform other logic here using the response
      },
      (error) => {
        // Handle error
        console.error('Error fetching data', error);
      }
    );
  }



  getPublicGroupAddon(groupId: string, authType: AuthType): Observable<Addon> {
    const url = `${environment.apiHost}/api/group/${groupId}/addon`;
    const options = { headers: this.buildAuthHeader(AuthType.None) };
    // const url = `assets/mock/addon.json`;
    // TODO uncomment before commit
    // const url = `${environment.apiHost}/api/group/${groupId}/addon`;
    return this.http.get<any>(url, options).pipe(
      map((addonsData) => {
        const addonData = addonsData.find(
          (a) => a.Type.toLowerCase() === authType
        );
        if (!addonData) {
          throw "No addon data find";
        }
        const resultAddon = new Addon();
        resultAddon.Type = authType;
        resultAddon.BaseUrl = addonData.BaseUrl;
        resultAddon.AccessToken = addonData.AccessToken;
        resultAddon.Domain = addonData.PublicProperties?.Domain;
        resultAddon.OrganziationId = addonData.PublicProperties?.OrganziationId;
        return resultAddon;
      })
    );
  }

  createNewAddon(addon: Addon, groupId: string, type: AuthType) {
    const authHeaders = this.buildAuthHeader(AuthType.Idenedi);
    const options = {
      headers: authHeaders, //.append("Idenedi-Api-Version", "4")
    };

    const data = {
      Version: "2",  // Version added to handle the tabOrder
      BaseUrl: "",
      AccessToken: "",
      RefreshToken: "",
      PrivateConfiguration: {},
      PublicProperties: addon.PublicProperties,
    };

    return this.http
      .post<any>(
        `${environment.apiHost}/api/group/${groupId}/addon?type=${type}`,
        data,
        options
      )
      .pipe(
        tap(() => {
          // Remove all and fetch again
          this._addonsData[groupId] = null;
          this.getAddonsAuth(groupId).subscribe();
        }
        )
      );
  }

  updateAddon(addon: Addon, groupId: string, resetCache = true) {
    const authHeaders = this.buildAuthHeader(AuthType.Idenedi);
    const options = {
      headers: authHeaders,
    };

    let data: any = {
      Version: "2", // Version added to handle the tabOrder
      BaseUrl: "",
      AccessToken: "",
      RefreshToken: "",
      PrivateConfiguration: {},
      PublicProperties: addon.PublicProperties,
    };

    return this.http
      .put<any>(
        `${environment.apiHost}/api/group/${groupId}/addon/${addon.InstanceId}`,
        data,
        options
      )
      .pipe(
        tap(() => {
          if (resetCache) {
            // Remove all and fetch again
            this._addonsData[groupId] = null;
            this.getAddonsAuth(groupId).subscribe();
          }
        })
      );
  }

  deleteAddon(groupId: string, addonId: string) {
    const authHeaders = this.buildAuthHeader(AuthType.Idenedi);
    const options = {
      headers: authHeaders,
    };

    return this.http
      .delete<any>(
        `${environment.apiHost}/api/group/${groupId}/addon/${addonId}`,
        options
      )
      .pipe(
        tap(() => {
          // Remove all and fetch again
          this._addonsData[groupId] = this._addonsData[groupId]?.filter(
            (item) => item.InstanceId != addonId
          );
          // this.getAddonsAuth(groupId).subscribe()
        })
      );
  }

  isJSON(str) {
    try {
      return JSON.parse(str) && !!str;
    } catch (e) {
      return false;
    }
  }

  initTabOrderAddon(tabOrderAddon: Addon): Addon {
    let parsed;


    if (this.isJSON(tabOrderAddon.PublicProperties.jsonData)) {
      parsed = JSON.parse(tabOrderAddon.PublicProperties.jsonData);
      parsed = JSON.parse(tabOrderAddon.PublicProperties.jsonData);
      parsed = JSON.parse(tabOrderAddon.PublicProperties.jsonData);
      parsed = JSON.parse(tabOrderAddon.PublicProperties.jsonData);
    } else {
      parsed = tabOrderAddon.PublicProperties.jsonData;
      parsed = tabOrderAddon.PublicProperties.jsonData;
      parsed = tabOrderAddon.PublicProperties.jsonData;
      parsed = tabOrderAddon.PublicProperties.jsonData;
    }

    // Ensure `data` is an array
    if (typeof parsed.data === "string") {
      try {
        parsed.data = JSON.parse(parsed.data);
      } catch (error) {
        console.error("Error parsing `data` field:", error, parsed.data);
      }
    }

    // List of fields that may be stringified JSON arrays
    const fieldsToParse = ["floatingTab", "footer", "footerUtilities", "socialFooterUtilities", "home", "utilities", "utilitiesText"];

    fieldsToParse.forEach(field => {
      if (typeof parsed[field] === "string") {
        try {
          parsed[field] = JSON.parse(parsed[field]);
        } catch (error) {
          console.error(`Error parsing '${field}' field:`, error, parsed[field]);
          parsed[field] = []; // Fallback to empty array in case of error
        }
      }
    });

    tabOrderAddon.PublicProperties.jsonData = parsed;
    return { ...tabOrderAddon };
  }



  initGroupLangAddon(addon: Addon): Addon {
    let parsed;
    if (this.isJSON(addon.PublicProperties.jsonData)) {
      parsed = JSON.parse(addon.PublicProperties.jsonData);
    } else {
      parsed = addon.PublicProperties.jsonData;
    }

    addon.PublicProperties.jsonData = parsed;
    return { ...addon };
  }
  clearCachedAddons(groupId: string) {
    this._addonsData[groupId] = null;
    window["GROUP_ADDONS"] = null;
    // this._groupWiseAddon$[groupId] = null;
  }
  ensureTechnadoptAuth(): Observable<Addon> {
    return this.getAddonsAuth(this.idenediGroupId).pipe(
      switchMap((addons) => {
        const technadoptAddon = addons.find(
          (addon) => addon.Type.toLowerCase() === AuthType.Technadopt
        );

        // We are only relogin to technadopt if the token is available but expired
        // otherwise we are not fetching it here because it would be unnecessary to call
        // we only need to that token when user goes to Products page. For that we have Productresolver
        if (technadoptAddon?.technadoptAuthData) {
          if (
            this.isTechnadoptTokenExpired(
              technadoptAddon.technadoptAuthData.expiresIn
            )
          ) {
            // Relogin
            technadoptAddon.technadoptAuthData = null;
            return this.getTechnadoptAuthorizedTokenIfRequired(technadoptAddon, this.idenediGroupId);
          }
        }

        return of(technadoptAddon);
      })
    );
  }

  isTechnadoptTokenExpired(expiresIn: number): boolean {
    return Date.now() > expiresIn - 60 * 1000;
  }

  isUserLoggedInThroughTechnadopt(): Observable<boolean> {
    return this.getAddonsAuth(this.idenediGroupId).pipe(
      switchMap((addons) => {
        const technadoptAddon = addons.find(
          (addon) => addon.Type.toLowerCase() === AuthType.Technadopt
        );
        if (technadoptAddon.technadoptAuthData) {
          return of(true);
        }
        return of(false);
      })
    );
  }

  getTechnadoptAuthorizedTokenIfRequired(
    technadoptAddon: Addon,
    groupId?: string
  ): Observable<Addon> {
    if (
      technadoptAddon &&
      (!technadoptAddon.technadoptAuthData ||
        this.isTechnadoptTokenExpired(
          technadoptAddon.technadoptAuthData.expiresIn
        ))
    ) {
      if (!this.isLoggedIn()) {
        return of(technadoptAddon);
      }
      // Relogin
      // technadoptAddon.technadoptAuthData = null //If second condition is met (token is expired) then we remove the technadoptAuthData so that it doesn't keep calling
      return this.getIdenediAuthorizationCodeForClient(
        environment.exceederClientId,
        groupId
      ).pipe(
        switchMap((code) => {
          return this.getTechnadoptToken(technadoptAddon.BaseUrl, code);
        }),
        catchError((e) => {
          console.info("Technadopt token not available");
          return of(null);
        })
      );
    } else {
      return of(technadoptAddon);
    }
  }

  ensureEspToken(): Observable<Addon> {
    return this.getAddonsAuth(this.idenediGroupId).pipe(
      switchMap((addons) => {
        const espAddon = addons.find(
          (addon) => addon.Type.toLowerCase() === AuthType.ESP.toLowerCase()
        );
        if (espAddon) {
          return of(espAddon);
        } else {
          return of(null);
        }
      })
    );
  }

  ensureSimpleStrataToken(): Observable<Addon> {
    return this.getAddonsAuth(this.idenediGroupId).pipe(
      switchMap((addons) => {
        const simpleStrataAddon = addons.find(
          (addon) =>
            addon.Type.toLowerCase() === AuthType.SimpleStrata.toLowerCase()
        );
        if (simpleStrataAddon) {
          return of(simpleStrataAddon);
        } else {
          return of(null);
        }
      })
    );
  }

  ensureNotificationServiceToken(): Observable<Addon> {
    return this.getAddonsAuth(this.idenediGroupId).pipe(
      switchMap(addons => {
        const notificationServiceAddon = addons.find(
          addon =>
            addon.Type.toLowerCase() === AuthType.NotificationService.toLowerCase()
        );
        if (notificationServiceAddon) {
          return of(notificationServiceAddon);
        } else {
          return of(null);
        }
      })
    );
  }

  ensurePlanneXeToken(): Observable<Addon> {
    return this.getAddonsAuth(this.idenediGroupId).pipe(
      switchMap((addons) => {
        const plannexeAddon = addons.find(
          (addon) =>
            addon.Type.toLowerCase() === AuthType.Plannexe.toLowerCase() || addon.Type.toLowerCase() === AuthType.plannexe.toLowerCase()
        );
        if (plannexeAddon) {
          return of(plannexeAddon);
        } else {
          return of(null);
        }
      })
    );
  }

  ensureHigherToken(): Observable<Addon> {
    return this.getAddonsAuth(this.idenediGroupId).pipe(
      switchMap((addons) => {
        const HigherAddon = addons.find(
          (addon) =>
            addon.Type.toLowerCase() === AuthType.Higher.toLowerCase()
        );
        if (HigherAddon) {
          return of(HigherAddon);
        } else {
          return of(null);
        }
      })
    );
  }

  getAuthType(request: HttpRequest<any>): AuthType {
    return (request.headers.get(AUTH_TYPE_HEADER) as AuthType) || AuthType.None;
  }

  buildAuthHeader(authType: AuthType, engProUserId?: string): HttpHeaders {
    this.checkUserRole();
    this.getLanguage();
    let headers;
    if (authType == AuthType.SimpleStrata) {
      if (!!engProUserId && engProUserId != null && engProUserId != "") {
        headers = new HttpHeaders({
          [AUTH_TYPE_HEADER]: authType,
          "client-id": "web",
          // locale: "en",
          locale: this.isArabic ? '*' : '*',
          EngProLoggedInUserId: engProUserId,
        });
      } else {
        headers = new HttpHeaders({
          [AUTH_TYPE_HEADER]: authType,
          "client-id": "web",
          // locale: "en",
          locale: this.isArabic ? '*' : '*'
        });
      }
    } else {
      headers = new HttpHeaders({
        [AUTH_TYPE_HEADER]: authType,
      });
    }

    return headers;
  }

  getAuthAddonByType(authType: AuthType): Observable<Addon> {
    switch (authType) {
      case AuthType.Idenedi:
        return this.ensureIdenediToken().pipe(
          map((token) => {
            return this.createAddon(token);
          })
        );
      case AuthType.Technadopt:
        return this.ensureTechnadoptAuth();
      case AuthType.ESP:
        return this.ensureEspToken().pipe(
          map((addon) => {
            return addon;
          })
        );
      case AuthType.SimpleStrata:
        return this.ensureSimpleStrataToken().pipe(
          map((addon) => {
            return addon;
          })
        );
      case AuthType.Plannexe:
      case AuthType.plannexe:
        return this.ensurePlanneXeToken().pipe(
          map((addon) => {
            return addon;
          })
        );
      case AuthType.Higher:
        return this.ensureHigherToken().pipe(
          map((addon) => {
            return addon;
          })
        );
      case AuthType.NotificationService:
        return this.ensureNotificationServiceToken();
      case AuthType.Higher:
        return this.ensureHigherToken().pipe(
          map((addon) => {
            return addon;
          })
        );
      default:
        return of(null);
    }
  }

  getEspToken(groupId: string) {
    if (this._addonsData[groupId]?.length) {
      const addon = this._addonsData[groupId].find(
        (x) => x.Type == AuthType.ESP
      );
      if (addon) {
        return addon.AccessToken;
      }
    }
    return null;
  }

  getIdenediAuthorizationCodeForClient(clientId: string, groupId?: string): Observable<string> {
    let url = `${environment.idenediProviderUrl}/api/oauth/AuthorizationCode?client_id=${clientId}`;
    if (this.idenediGroupId) {
      url = `${environment.idenediProviderUrl}/api/oauth/AuthorizationCode?client_id=${clientId}&gIdenedi=${this.idenediGroupId}`;
    }
    const options = {
      headers: this.buildAuthHeader(AuthType.Idenedi),
    };
    return this.http.get<any>(url, options).pipe(
      map((code) => {
        return code;
      })
    );
  }

  getTechnadoptToken(baseURL: string, authCode: string): Observable<any> {
    const body = new HttpParams({
      fromObject: {
        code: authCode,
        grant_type: "idenedi",
      },
    });
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return this.http.post(baseURL + "token", body.toString(), { headers }).pipe(
      switchMap((tokenData: any) => {
        return this.getAuthAddonByType(AuthType.Technadopt).pipe(
          tap((addOn) => {
            if (addOn) {
              addOn.technadoptAuthData = {
                accessToken: tokenData.access_token,
                expiresIn: Date.now() + tokenData.expires_in * 1000,
                roles: JSON.parse(tokenData.roles ?? "[]"),
              };
            }
          })
        );
      }),
      catchError((e) => {
        throw ApiError.fromResponse(e);
      })
    );
  }

  getNotificationServiceToken(): Observable<Addon> {
    return this.getAddonsAuth(this.idenediGroupId).pipe(
      map(addons => {
        return addons.find(ad => ad.Type?.toLowerCase() == AuthType.NotificationService.toLowerCase())
      }),
      switchMap(addon => {
        if (!addon) {
          return of(null);
        }
        if (addon?.AccessToken) {
          return of(addon);
        } else {
          const clientId = addon?.PublicProperties?.client_id;
          const clientSecret = addon?.Configuration?.client_secret;
          const EXCEED_NOTIFICATION_SERVICE_TOKEN = "notification.service.token";
          return this.getNSAccessToken(addon?.PublicProperties?.authUrl, clientId, clientSecret)
            .pipe(
              map((resp: any) => {
                localStorage.setItem(EXCEED_NOTIFICATION_SERVICE_TOKEN, resp.access_token);
                addon.AccessToken = resp?.access_token;
                return addon;
              })
            );
        }
      })
    );
  }

  getNSAccessToken(authUrl: string, clientId: string, clientSecret: string) {

    const body = new HttpParams({
      fromObject: {
        client_id: clientId,
        client_secret: clientSecret,
        grant_type: "client_credentials",
      }
    });
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded"
    });
    return this.http.post(`${authUrl}/connect/token`, body.toString(), { headers })
  }

  // getTechnadoptTokenByCredentials(
  //   username: string,
  //   password: string
  // ): Observable<any> {
  //   const body = new HttpParams({
  //     fromObject: {
  //       code: authCode,
  //       grant_type: "password"
  //     }
  //   });
  //   const headers = new HttpHeaders({
  //     "Content-Type": "application/x-www-form-urlencoded"
  //   });
  //   return this.getIdenediAuthorizationCodeForClient(
  //     environment.exceederClientId
  //   ).pipe(
  //     switchMap(res => {
  //       return;
  //     })
  //   );
  // }
  getTokenByAuthorizationCode(
    baseURL: string,
    authCode: string
  ): Observable<any> {
    const body = new HttpParams({
      fromObject: {
        code: authCode,
        grant_type: "idenedi",
      },
    });
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return this.http.post(baseURL + "token", body.toString(), { headers });
  }
  private removeEspToken() {
    if (this._addonsData[this.idenediGroupId]?.length) {
      const addon = this._addonsData[this.idenediGroupId].find(
        (x) => x.Type == AuthType.ESP
      );
      if (addon) {
        addon.AccessToken = null;
      }
    }
  }
  getIdenediAccountProvider(provider: string): Observable<any> {
    const authHeaders = this.buildAuthHeader(AuthType.Idenedi);
    const options = {
      headers: authHeaders,
    };

    return this.http.get<any>(
      `${environment.apiHost}/api/accountprovider/${provider}`,
      options
    );
  }
  private createAddon(token: string): Addon {
    const addon: Addon = new Addon();
    addon.AccessToken = token;
    return addon;
  }

  public refetchAuthAddons(groupId: string, subscribeLater = false) {
    //Remove all and fetch again
    this._addonsData[groupId] = [];
    window["GROUP_ADDONS"] = null;
    if (subscribeLater) {
      return this.getAddonsAuth(groupId);
    }
    this.getAddonsAuth(groupId).subscribe();
  }

  getAddonsData() {
    return this._addonsData[this.idenediGroupId];
  }

  getAddonBySubtype(
    subtype: SubTypeEnum,
    productId: string
  ): Observable<Addon> {
    return this.getAddonsAuth(this.idenediGroupId).pipe(
      map((addons) => {
        return addons.find(
          (a) =>
            a.PublicProperties.subtype == subtype &&
            a.PublicProperties.productId == productId
        );
      })
    );
  }

  getAddonForCustumTabRequest(productId: number): Observable<Addon> {
    return this.getAddonBySubtype(SubTypeEnum.REQUEST, productId.toString());
  }
  
  getAddonNameForCustumTabRequest(definitionId: number): Observable<string> {
    return this.getAddonsAuth(this.idenediGroupId).pipe(
      map((addons: Addon[]) => {
        const addon = addons.find(
          (a) =>
            a.PublicProperties?.subtype == SubTypeEnum.REQUEST &&
            a.PublicProperties?.productId == definitionId?.toString()
        );
        if (!addon) {
          return '';
        }
        // Translated tab names live in the GroupLanguages addon, keyed by locale then tab InstanceId
        const langAddon = addons.find(
          (a) => a.Type?.toLowerCase() == AuthType.GroupLanguages.toLowerCase()
        );
        const currentLang = langAddon?.PublicProperties?.jsonData?.[this._exdrLanguageService.currentLanguage?.locale];
        const translatedName = currentLang?.settings?.isEnable == "1" ? currentLang?.[addon.InstanceId]?.name : '';
        return translatedName || addon.PublicProperties?.name || '';
      }),
      map((name: string) => {
        if(name) {
          return name;
        }
        return this.translate.instant('All');
      })
    );
  }

  getLanguage() {
    let lang: any = localStorage.getItem("preferredLanguage")
      ? JSON.parse(localStorage.getItem("preferredLanguage"))
      : "";
    if (lang) this.isArabic = lang.locale == "ar" || false;
  }

  checkUserRole() {
    // this.groupsService
    //   .getGroupDetailsPublic(this.authService.idenediGroupId)
    //   .subscribe((group) => {
    //     this.isAdmin = group?.IsAdmin ?? false;
    //   });
  }

  // ext_list_query: send a dynamic payload and expect an object containing a key
  externalIdProvider(groupId: string, providerInstanceId: string, payload: Record<string, any>): Observable<string> {
    const url = `${environment.apiHost}/api/${encodeURIComponent(groupId)}/externalIdProvider/${encodeURIComponent(providerInstanceId)}/ext_list_query`;
    return this.http.post<any>(url, payload)
  }
}
